<template>
  <el-dialog
    :inline = "true"
    width="70%"
    :title="$t('LoginApplyDialog.application_information')"
    :visible.sync="visible"
    @close="close">

      <el-form :inline="true" :model="applyForm" label-position="left" label-width="130px">

        <el-form-item :label="`${$t('LoginApplyDialog.name')}:`">
          <el-input size="mini" v-model="applyForm.name" autocomplete="off" :disabled="true" ></el-input>
        </el-form-item>

        <el-form-item :label="`${$t('LoginApplyDialog.useremail')}:`">
          <el-input size="mini" v-model="applyForm.useremail" autocomplete="off" :disabled="true" ></el-input>
        </el-form-item>

        <el-form-item :label="`${$t('LoginApplyDialog.applycop')}:`">
          <el-input size="mini" v-model="applyForm.applycop" autocomplete="off" :disabled="true" ></el-input>
        </el-form-item>

        <el-form-item :label="`${$t('LoginApplyDialog.id')}:`" >
          <el-input size="mini" v-model="applyForm.id" autocomplete="off" :disabled="true" ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('LoginApplyDialog.obs_id')}:`">
          <el-input size="mini" v-model="applyForm.obs_id" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('LoginApplyDialog.proposal')}:`">
          <el-input size="mini" v-model="applyForm.proposal" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item :label="`${$t('LoginApplyDialog.userposition')}:*`">
          <el-select style="width:180px;" v-model="applyForm.userposition"  filterable :placeholder="$t('LoginApplyDialog.userposition_tip')"
            @change="changeuserposition">
            <el-option
                v-for="item in userpostselect"
                :key="item.value"
                :disabled="item.disable"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('LoginApplyDialog.remark')}:*`">
          <el-input size="mini"  style="width:500px;"  v-model="applyForm.remark" autocomplete="off" ></el-input>
        </el-form-item>

        <el-radio-group v-model="applyForm.includeproposal">
          <el-radio :label="1">{{$t('LoginApplyDialog.includeproposal.one')}}</el-radio>
          <el-radio :label="2">{{$t('LoginApplyDialog.includeproposal.two')}}</el-radio>
          <el-radio :label="3">{{$t('LoginApplyDialog.includeproposal.three')}}</el-radio>
        </el-radio-group>
        <el-divider></el-divider>



        <el-collapse v-model="infoCollapse" accordion>
          <el-collapse-item :inline="true" :title="`${$t('LoginApplyDialog.tutorinfo')}:`"  name="1" :disabled="partnersinfov"> 
            <el-form-item :label="`${$t('LoginApplyDialog.tutorname')}:*`">
              <el-input size="mini" v-model="applyForm.tutorname" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('LoginApplyDialog.tutoremail')}:*`">
              <el-input size="mini" style="width:300px;"  v-model="applyForm.tutoremail" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('LoginApplyDialog.tutoropion')}:`" v-if="false">
              <el-input size="mini" v-model="applyForm.tutoropion" autocomplete="off" v-if="false"></el-input>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item :inline="true" :title="`${$t('LoginApplyDialog.partnersinfo')}:`" name="2" :disabled="tutorinfov">
            <el-form-item :label="`${$t('LoginApplyDialog.partnersname')}:*`">
              <el-input size="mini" v-model="applyForm.partnersname" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('LoginApplyDialog.partnersemail')}:*`">
              <el-input size="mini" v-model="applyForm.partnersemail" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('LoginApplyDialog.partnersopion')}:`" v-if="false">
              <el-input size="mini" v-model="applyForm.partnersopion" autocomplete="off" v-if="false"></el-input>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        
        <el-divider content-position="left">{{$t('LoginApplyDialog.required')}}</el-divider>
      
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close">{{$t('LoginApplyDialog.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="ok">{{$t('LoginApplyDialog.ok')}}</el-button>
      </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { UserPositionen, UserPositionzh } from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: '',
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      applyForm: {
        umtId:'',
        cstnetId:'',
        id:'',
        obs_id:'',
        target:'',
        obs_mode:'',
        proposal:'',
        includeproposal : 1,
        name: '',
        useremail: '',
        applycop: '', 
        userposition:'',           
        remark:'',
        tutorname:'',
        tutoremail:'',
        partnersname:'',
        partnersemail:'',
        info:'提示信息',
      },
      visible: false,
      tutorinfov:true,
      partnersinfov:true,
      infoCollapse:"",
    };
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
    userpostselect(){
      if (this.language === 'en') {
        return UserPositionen.map((item) => {
          let disable = false;
          if (this.userInfo && this.userInfo.iscore && item.value !== 'core') {
            disable = true;
          } else if (this.userInfo && !this.userInfo.iscore && item.value === 'core'){
            disable = true;
          }
          return {
            ...item,
            disable,
          };
        });
      } else {
        return UserPositionzh.map((item) => {
          let disable = false;
          if (this.userInfo && this.userInfo.iscore && item.value !== 'core') {
            disable = true;
          } else if (this.userInfo && !this.userInfo.iscore && item.value === 'core'){
            disable = true;
          }
          return {
            ...item,
            disable
          };
        });
      }
    },
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
    },
    dialogData(data){
      // console.log('用户信息',this.userInfo);
      this.applyForm.umtId = this.userInfo.umtId;
      this.applyForm.cstnetId = this.userInfo.cstnetId;
      this.applyForm.id = data.id;
      this.applyForm.obs_id = data.obs_id;
      this.applyForm.target = data.target;
      this.applyForm.obs_mode = data.obs_mode;
      this.applyForm.proposal = data.proposal;
      this.applyForm.name = this.userInfo.truename;
      this.applyForm.useremail = this.userInfo.useremail;
      this.applyForm.applycop = this.userInfo.usercp;
      if(this.userInfo.iscore){
        this.applyForm.userposition = 'core';
      }else{
        this.applyForm.userposition = '';
      }
    },
    
  },
  
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      if(!this.CheckisNull()){
        return null
      }
      this.$emit('ok', {
        ...this.applyForm,
      });
    },
    changeuserposition(val){
      if(val==="student"){
        this.tutorinfov = true;
        this.infoCollapse = "1";
        this.partnersinfov = false;
      }else if(val==="noncore"){
        this.partnersinfov = true;
        this.tutorinfov = false;
        this.infoCollapse = "2";
      }else if(val==="core"){
        this.infoCollapse = "0";
        this.partnersinfov = true;
        this.tutorinfov = true;
      }
    },

    CheckisNull(){
      // console.log("检测字段",this.applyForm.userposition); /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/
      // var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+([-_.][A-Za-zd]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(this.applyForm.useremail != '' && !regEmail.test(this.applyForm.useremail)){
          this.$alert(this.$t('LoginApplyDialog.messinfo.useremailbox_detection'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
      }
      if(this.applyForm.userposition===""){
        this.$alert(this.$t('LoginApplyDialog.messinfo.userposition'), '提示(Tips)', {
          confirmButtonText: '确定(Ok)',
          callback: action => {
            this.$message({
              type: 'warning',
              message: `action: ${ action }`
            });
          }
        });
        return false;
      }else if(this.applyForm.userposition === "student"){
        if(this.applyForm.tutoremail != '' && !regEmail.test(this.applyForm.tutoremail)){
          this.$alert(this.$t('LoginApplyDialog.messinfo.tutormailbox_detection'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
        }
        if(this.applyForm.remark===""||this.applyForm.tutorname===""||this.applyForm.tutoremail===""){
          this.$alert(this.$t('LoginApplyDialog.messinfo.student'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
        }else{
          return true;
        }
      }else if(this.applyForm.userposition === "core"){
        if(this.applyForm.remark===""){
          this.$alert(this.$t('LoginApplyDialog.messinfo.core'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
        }else{
          return true;
        }
      }else if(this.applyForm.userposition === "noncore"){
        if(this.applyForm.partnersemail != '' && !regEmail.test(this.applyForm.partnersemail)){
          this.$alert(this.$t('LoginApplyDialog.messinfo.partnersemail_detection'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
        }
        if(this.applyForm.remark===""||this.applyForm.partnersname===""||this.applyForm.partnersemail===""){
          this.$alert(this.$t('LoginApplyDialog.messinfo.noncore'), '提示(Tips)', {
            confirmButtonText: '确定(Ok)',
            callback: action => {
              this.$message({
                type: 'warning',
                message: `action: ${ action }`
              });
            }
          });
          return false;
        }else{
          return true;
        }
      }
    },
  }
}
</script>
